module.exports = __webpack_public_path__ + "images/167_1024.jpg";